<div class="wrapper">
  <p-menu [model]="menuItems"></p-menu>
  <div class="main-content">
    <router-outlet></router-outlet>
  </div>
</div>
